jQuery.cookie = function (b, j, m) {
  if (typeof j != 'undefined') {
    m = m || {};
    if (j === null) {
      j = '';
      m.expires = -1;
    }
    var e = '';
    if (m.expires && (typeof m.expires == 'number' || m.expires.toUTCString)) {
      var f;
      if (typeof m.expires == 'number') {
        f = new Date();
        f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1000);
      } else {
        f = m.expires;
      }
      e = '; expires=' + f.toUTCString();
    }
    var l = m.path ? '; path=' + m.path : '';
    var g = m.domain ? '; domain=' + m.domain : '';
    var a = m.secure ? '; secure' : '';
    document.cookie = [b, '=', encodeURIComponent(j), e, l, g, a].join('');
  } else {
    var d = null;
    if (document.cookie && document.cookie != '') {
      var k = document.cookie.split(';');
      for (var h = 0; h < k.length; h++) {
        var c = jQuery.trim(k[h]);
        if (c.substring(0, b.length + 1) == b + '=') {
          d = decodeURIComponent(c.substring(b.length + 1));
          break;
        }
      }
    }
    return d;
  }
};
window.$ &&
  $(document).ready(function () {
    switchTabButtonToGoods();
    imgNavTab();
    mediaGalleryMethod();
    mobilescroll();
    productDetailSwitchConfigMethod();
    $(document)
      .on('click', '.apply-discount-btn', function (e) {
        e.preventDefault();
        applyDiscount(
          $(this)
            .parent('.cart-sidebar-discount')
            .find('#discount-code-input')
            .val()
        );
      })
      .on(
        'click',
        '.applied-discount-code .applied-discount-code-wrapper,#clear-discount-btn',
        function (e) {
          e.preventDefault();
          let current_code = $(this).attr('data');
          clearDiscount(current_code);
        }
      );
    $('.instagram_product_handle').each(function () {
      var product_handle_str = $(this).attr('data');
      var product_info = getProductInfo(
        product_handle_str,
        $(this),
        getInstagramProductInfo
      );
    });
    instagramGalleryMethod();
    if ($('.product-section').length) {
      setTimeout(function () {
        ajaxGetSections(
          'template--27571989020974__section_instagram_gallery_page',
          $('.shopify-app-block[id*=judge_me_reviews_review_widget]').parents(
            '.shopify-section'
          ),
          getProductnstagram
        );
      }, 2500);
    }

    var btn_top = $('.back-to-top');
    $(window).scroll(function () {
      if ($(window).scrollTop() > 300) {
        btn_top.addClass('active');
      } else {
        btn_top.removeClass('active');
      }
    });
    btn_top.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, '300');
    });

    popup();
    cookiepopup();
    checkEmailValMethod();

    $(document).on('click', '.coupon-copy-btn', function (e) {
      copyMethod($(this).attr('data'));
    });
    getShippingRate();
  });

function copyMethod(spu_no) {
  try {
    const newInput = document.createElement('input');
    newInput.value = spu_no;
    document.body.appendChild(newInput);
    newInput.select();
    document.execCommand('Copy');
    newInput.remove();
    showCustomModal();
  } catch (e) {
    console.log(e);
  }
}
function showCustomModal() {
  //var modal = document.getElementById("customModal");
  //modal.style.display = "block";
  $('.ant-message').css('display', 'block');
  $('.newsletter-subscribed-success-popup').hide();
  setTimeout(function () {
    hideCustomModal();
  }, 2000);
}
function hideCustomModal() {
  //var modal = document.getElementById("customModal");
  //modal.style.display = "none";
  $('.ant-message').css('display', 'none');
}

function checkEmailValMethod() {
  // 邮箱校验
  $('#mc_embed_signup .form-group .form-control').on('input', function (event) {
    const isPass =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        event.target.value
      );
    $('#mc_embed_signup .form-group .control_error_tip').remove();
    $('#mc_embed_signup .form-group .btn-primary').attr('disabled', false);
    if (!isPass) {
      const msg = event.target.value
        ? 'Please enter a valid email address. For example sk@sikaic.com'
        : 'This is a required field';
      $(this).after('<p class="control_error_tip">' + msg + '</p>');
      $('#mc_embed_signup .form-group .btn-primary').attr('disabled', true);
    }
  });
}

function popup() {
  $('.jsclosepoup').on('click', function () {
    $('.jsengo_popup').hide();
  });
}
function cookiepopup() {
  productCoupupIcon();
  if (
    !jQuery.cookie('success_pop_newletter') &&
    (!jQuery.cookie('brilliant_pop_newletter') ||
      jQuery.cookie('brilliant_pop_newletter') == null ||
      jQuery.cookie('brilliant_pop_newletter') == 0 ||
      jQuery.cookie('brilliant_pop_newletter') == undefined)
  ) {
    $(window).on('load', function () {
      setTimeout(function () {
        $('.jsengo_popup').show();
      }, 10 * 1000);
      jQuery('.jsclosepoup').click(function (e) {
        e.preventDefault();
        jQuery('.jsengo_popup').hide();
        $('.sub-coupup_icon_pc').removeClass('hide');
        //jQuery.cookie('brilliant_pop_newletter', '1', {expires: 1, path:'/', domain: '' });                                        });
      });
    });
    jQuery.cookie('brilliant_pop_newletter', '1', {
      expires: 1,
      path: '/',
      domain: '',
    });
  } else {
    //$('.jsengo_popup').remove();
  }
}
function productCoupupIcon() {
  //优惠券事件
  $(document).on('click', '.sub-coupup_icon_pc_content', function (e) {
    //alert(jQuery.cookie('success_pop_newletter'))
    if (jQuery.cookie('success_pop_newletter')) {
      // 已订阅
      const isHidden = $('.newsletter-subscribed-success-popup').is(':hidden');
      if (isHidden) {
        $('.newsletter-subscribed-success-popup')
          .html($('.newsletter-subscribed-success-already').html())
          .show();
        setTimeout(() => {
          $('.newsletter-subscribed-success-popup').hide();
        }, 5000);
      } else {
        $('.newsletter-subscribed-success-popup').hide();
      }
    } else {
      // 没有订阅
      $('.jsengo_popup').show();
    }
  });
  $(document).on('click', '.coupon-copy-code-btn', function (e) {
    copyMethod($(this).attr('data'));
  });
  if ($('.newsletter-subscribed-success-ok').length > 0) {
    jQuery.cookie('success_pop_newletter', '1', {
      expires: 1,
      path: '/',
      domain: '',
    });
  }
  if (
    jQuery.cookie('success_pop_newletter') ||
    jQuery.cookie('brilliant_pop_newletter')
  ) {
    //已订阅和已弹窗
    $('.sub-coupup_icon_pc').removeClass('hide');
  }
}

function ajaxGetSections(section_filename, ele_obj, callback) {
  if (section_filename && ele_obj && callback) {
    $.ajax({
      url: '/?sections=' + section_filename,
      type: 'GET',
      dataType: 'json',
      cache: false,
      success: function (data) {
        callback(section_filename, ele_obj, data);
      },
      error: function (data) {
        console.log('section', data);
      },
    });
  }
}

function menuScrollMethod(navLi) {
  //const isHave = $('.section-float-nav-new .row ').hasClass('section-float-nav-mobile-new');
  //const navLi = isHave ? $('.section-float-nav-new .row .section-float-nav-ul li') : $('.section-float-nav .row .section-float-nav-ul li');
  let arr = [];
  for (let i = 0; i < navLi.length; i++) {
    const idName = $(navLi[i]).find('a').attr('href');
    const heightData = $(idName).length > 0 && movingDistance($(idName));
    arr.push({
      id: idName,
      left:
        $(navLi[i]).length > 0
          ? parseInt($(navLi[i])[0].getBoundingClientRect().left)
          : 0,
      range: heightData ? heightData.positionRange : [0, 0],
      top: heightData ? heightData.top : 0,
    });
    if ($(window).width() > 990) {
      $(idName).on('mouseenter', function () {
        const curTop = parseInt($(idName)[0].getBoundingClientRect().top);
        const haveData = arr.filter((v) => v.id == idName);
        const indexN = arr.findIndex((v) => v.id == idName);
        const topValue1 = haveData.length > 0 ? parseInt(haveData[0].top) : 0;
        if (topValue1 == curTop) {
          // 当前页面是否在滚动
          return;
        }
        if (indexN > -1) {
          arr[indexN].top = curTop;
        }
        const str = 'a[href="' + idName + '"]';
        const dom = navLi.find(str).parent();
        const curIndex = dom.index();
        dom.addClass('li-active').siblings().removeClass('li-active');
        if (curIndex > 4 || curIndex < 3) {
          curIndex > 4 &&
            $('.section-float-nav .section-float-nav-ul .next-slide').click();
          curIndex < 3 &&
            $('.section-float-nav .section-float-nav-ul .prev-slide').click();
        }
      });
    } else {
      $(document).on('touchstart', idName, function () {
        const str = 'a[href="' + idName + '"]';
        const dom = navLi.find(str).parent();
        const curIndex = dom.index();
        const checkChildDom =
          dom.length > 0 ? dom[0].getBoundingClientRect().left : 0;
        dom.addClass('li-active').siblings().removeClass('li-active');
        let scrollWidth = parseInt(
          document.querySelector('.row .section-float-nav-ul').scrollLeft
        ); // 滚动的宽度+元素与窗口的距离
        debounce(
          moveToNavItem(
            '.row .section-float-nav-ul',
            checkChildDom + scrollWidth + 20
          ),
          5
        );
        //const haveData = arr.filter(v => v.id == idName);
        //const leftValue1 = haveData.length > 0 ? haveData[0].left : checkChildDom;
        //moveToNavItem('.row .section-float-nav-ul', checkChildDom ? checkChildDom.left : 0 )
      });
      if ($('#bundle-product-view-id').length == 0) {
        $(navLi[i]).find('a[href="#bundle-product-view-id"]').parent().hide();
      }
    }
  }
}

function movingDistance($dom) {
  if ($dom && $dom.length == 0) {
    return;
  }
  let idNameDom = $dom.length > 0 ? $dom[0].getBoundingClientRect() : null;
  let idNameDomTop = idNameDom ? parseInt(idNameDom.top) : 0;
  let idNameDomLeft = idNameDom ? parseInt(idNameDom.left) : 0;
  let idNameDomBottom = idNameDom ? parseInt(idNameDom.bottom) : 0;
  let idNameDomHeight = idNameDom ? parseInt(idNameDom.height) : 0;
  let scrollHeigth =
    parseInt(document.documentElement.scrollTop) || parseInt(window.scrollY); // 滚动的高度+元素与窗口的距离
  let idNameRange = [
    idNameDomTop + scrollHeigth,
    idNameDomTop + idNameDomHeight + scrollHeigth,
  ]; // 元素位置所处的范围
  return {
    top: idNameDomTop, // 离body的距离
    height: idNameDomHeight, // 元素的高度
    scrollHeigth: scrollHeigth, // 滚动的高度
    positionRange: idNameRange, // 元素位置的范围
    left: idNameDomLeft,
    bottom: idNameDomBottom,
  };
}

function moveToNavItem(className, leftValue = 0, top = 0) {
  document.querySelector(className).scrollTo({
    top: top,
    left: leftValue,
    behavior: 'smooth',
  });
}

function debounce(fn, delay) {
  // 节流函数，频繁操作只执行一次
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}
function switchTabButtonToGoods() {
  // 切换按钮到对应的商品菜单
  setTimeout(function () {
    $('.section-float-nav .row .section-float-nav-ul li').length > 0 &&
      menuScrollMethod($('.section-float-nav .row .section-float-nav-ul li'));
    $('.section-float-nav-new .row .section-float-nav-ul li').length > 0 &&
      menuScrollMethod(
        $('.section-float-nav-new .row .section-float-nav-ul li')
      );
    if (
      $('.section-float-nav-new-v2 .row .section-float-nav-ul li').length > 0
    ) {
      menuScrollMethod($('.section-float-nav-new-v2 .section-float-nav-ul li'));
      $('.section-float-nav-new-v2 .container-v2').css('visibility', 'visible');
      //const isHidden = $('.menu_moblie .header_top_bar_block').is(':hidden');
      //$(window).width() < 990 && $(".section-float-nav-new-v2").css('top', isHidden ? '53px' : '97px');
    }
  }, 500);
  $(document).on('click', '.row .section-float-nav-ul li', function (e) {
    const curIndex = $(this).index();
    const idName = $(this).find('a').attr('href');
    const heightData = $(idName).length > 0 && movingDistance($(idName));
    const parentsClass = $(this)
      .parents('div[data-section-type]')
      .attr('data-section-type');
    $(this).addClass('li-active').siblings().removeClass('li-active');
    let scollHeight = 75;
    if ($(window).width() < 990) {
      // M端
      const navDom = $('.mobile-model-nav .section-float-nav-ul li');
      navDom.removeClass('li-active');
      navDom.eq(curIndex).addClass('li-active');
      scollHeight = 97;
    } else {
      // pc
      scollHeight = 20;
    }
    const mobileDom = $('.mobile-model-nav');
    const isHiden = mobileDom.is(':hidden');
    if (!isHiden) {
      mobileDom.hide();
      $(this).removeClass('up-style').addClass('down-style');
    }
    let fixBarHeight = 75;
    if (parentsClass == 'section-float-nav-new') {
      fixBarHeight = parseInt($('.section-float-nav-new').height()) + 90;
    } else if (parentsClass == 'section-float-nav-new-v2') {
      fixBarHeight =
        parseInt($('.section-float-nav-new-v2').height()) + scollHeight;
    } else if (parentsClass == 'section-float-nav') {
      fixBarHeight = parseInt($('.section-float-nav').height()) + 75;
    }
    //const isHave = $('.section-float-nav-new .row ').hasClass('section-float-nav-mobile-new');
    //const fixBarHeight = isHave ? parseInt($('.section-float-nav-new').height())+90 : parseInt($('.section-float-nav').height())+75;
    $(idName).css('scroll-margin-top', fixBarHeight + 'px');
    e.preventDefault();
    const curScrollTop = heightData ? heightData.scrollHeigth : 0;
    const idNameDomTop = heightData ? heightData.top : 0;
    document.documentElement.scrollTop = parseInt(
      idNameDomTop + curScrollTop - fixBarHeight
    );
  });

  $(document).on(
    'click',
    '.mobile-model-nav .section-float-nav-ul li',
    function (e) {
      // m端下拉点击菜单
      if ($(window).width() < 990) {
        const curIndex = $(this).index();
        const liDom = $('.row .section-float-nav-ul li');
        const idName = $(this).find('a').attr('href');
        const heightData = $(idName).length > 0 && movingDistance($(idName));
        const parentsClass = $(this)
          .parents('div[data-section-type]')
          .attr('data-section-type');
        $(this).addClass('li-active').siblings().removeClass('li-active');
        liDom.removeClass('li-active');
        liDom.eq(curIndex).addClass('li-active');
        $('.mobile-model-nav').hide();
        $('.row .mobile-down-btn')
          .removeClass('up-style')
          .addClass('down-style');
        const childDom = document.querySelector(
          '.row .section-float-nav-ul'
        ).children;
        const checkChildDom =
          childDom.length > 0
            ? childDom[curIndex].getBoundingClientRect()
            : null;
        const scrollWidth = parseInt(
          document.querySelector('.row .section-float-nav-ul').scrollLeft
        ); // 滚动的高度+元素与窗口的距离
        const leftWidth = checkChildDom ? checkChildDom.left : 0;
        moveToNavItem('.row .section-float-nav-ul', scrollWidth + leftWidth); // 菜单滚动条
        let fixBarHeight = 75;
        if (parentsClass == 'section-float-nav-new') {
          fixBarHeight = parseInt($('.section-float-nav-new').height()) + 90;
        } else if (parentsClass == 'section-float-nav-new-v2') {
          fixBarHeight =
            parseInt($('.section-float-nav-new-v2').height()) + 100;
        } else if (parentsClass == 'section-float-nav') {
          fixBarHeight = parseInt($('.section-float-nav').height()) + 75;
        }
        //const fixBarHeight = parseInt($('.section-float-nav').height())+75;
        $(idName).css('scroll-margin-top', fixBarHeight + 'px');
        e.preventDefault();
        const curScrollTop = heightData ? heightData.scrollHeigth : 0;
        const idNameDomTop = heightData ? heightData.top : 0;
        document.documentElement.scrollTop = parseInt(
          idNameDomTop + curScrollTop - fixBarHeight
        );
      }
    }
  );

  $(document).on('click', '.row .mobile-down-btn', function (e) {
    const isHiden = $('.mobile-model-nav').is(':hidden');
    const mobileDom = $('.mobile-model-nav');
    if (isHiden) {
      mobileDom.show();
      $(this).removeClass('down-style').addClass('up-style');
    } else {
      mobileDom.hide();
      $(this).removeClass('up-style').addClass('down-style');
    }
  });
  if ($(window).width() > 990) {
    $('.section-float-nav .section-float-nav-ul').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: false,
      vertical: false,
      verticalSwiping: true,
      prevArrow:
        '<button type="button" class="prev-slide" aria-label="prev"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
      nextArrow:
        '<button type="button" class="next-slide" aria-label="next"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
      focusOnSelect: true,
    });
  }
}

function slickObject(dom, pcNum = 1, mobileNum = 1, optionField = {}) {
  dom.slick({
    slidesToShow: $(window).width() > 990 ? pcNum : mobileNum,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: $(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '3px',
    prevArrow:
      '<button type="button" class="prev-slide" aria-label="prev"><svg fill="none" width="15" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="#fff" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
    nextArrow:
      '<button type="button" class="next-slide" aria-label="next"><svg fill="none" width="15" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="#fff" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
    focusOnSelect: false,
    ...optionField,
  });
  return dom;
}

function imgNavTab() {
  const option = {
    arrows: false,
    infinite: false,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
  };
  const slickDom = slickObject(
    $('.img-nav-tab-section .img-nav-tab-content'),
    1,
    1,
    option
  );
  $('.img-nav-tab-section .img-nav-tab-content').css('opacity', 1);
  $(document).on(
    'click',
    '.img-nav-tab-section .img-nav-tab-menu li',
    function (e) {
      const num = $(this).index();
      $(this).addClass('nav-li-active').siblings().removeClass('nav-li-active');
      slickDom.slick('slickGoTo', Number(num));
    }
  );
  slickDom.on('afterChange', function (e, slick, currentSlide) {
    $('.img-nav-tab-section .img-nav-tab-menu li')
      .eq(currentSlide)
      .addClass('nav-li-active')
      .siblings()
      .removeClass('nav-li-active');
  });
}

function mediaGalleryMethod() {
  const option = {
    arrows: $(window).width() > 990 ? true : false,
    infinite: false,
    dots: true,
    touchMove: $(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
    prevArrow:
      '<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:
      '<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
  };
  const option1 = {
    arrows: true,
    infinite: false,
    dots: $(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
    prevArrow:
      '<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:
      '<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
  };
  const option3 = {
    arrows: true,
    infinite: false,
    dots: $(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
    prevArrow:
      '<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:
      '<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
  };
  const slickDom1 = slickObject(
    $('.slide-products .js-slide-product'),
    4,
    1,
    option
  );
  const slickDom = slickObject(
    $('.media-gallery .js-media-gallery'),
    4,
    1,
    option3
  );
  $('.slide-products .js-slide-product').css('opacity', 1);
  $(window).width() < 990 &&
    slickObject($('.media-gallery-v2 .js-media-gallery-v2'), 1, 1, option1);
}

function mobilescroll() {
  const barHeight = $('div[id*=marquee_text_hfzJFj]').height(); //通知栏
  const headerHeight = $('.section-header').height(); // header
  const imgHeight = $('div[id*=hero_slideshow_]').height() || 0; //banner图
  const mHeight = $(window).width() < 990 ? 110 : 150;
  const isHave = $('.section-float-nav-new .row ').hasClass(
    'section-float-nav-mobile-new'
  ); // float-nav-new组件
  const curHeight = isHave
    ? parseInt($('#overview-product-view-id').height()) - 100
    : parseInt(imgHeight) - mHeight;
  const $nav = parseInt(barHeight) + parseInt(headerHeight);
  scrollNavMethod(curHeight, $nav, $(this));
  let lastScrollTop = 0;
  $(document).scroll(function () {
    const currentScrollTop = $(this).scrollTop();
    // if ($(window).width() < 990) {
    //   if (currentScrollTop > lastScrollTop) {
    //     $('.section-float-nav-new-v2').css('top', '22px');
    //   } else if (currentScrollTop < lastScrollTop) {
    //     $('.section-float-nav-new-v2').css('top', '0px');
    //   }
    // }
    lastScrollTop = currentScrollTop;
    scrollNavMethod(curHeight, $nav, $(this));
  });
}

function scrollNavMethod(curHeight, navHeight, dom) {
  console.log('curHeight:' + curHeight + 'navHeight:' + navHeight);
  if ($(window).width() < 990) {
    // 移动端菜单设置
    const isHideBar = window.localStorage.getItem('hideHeaderBar');
    // if (dom.scrollTop() > navHeight) { //滚动值大于主菜单栏
    //   //const heightData = isHideBar == 1 ? '53px' : '97px';
    //     $('.shopify-section.section-float-nav, .shopify-section.section-float-nav-new').css('top', '0px');
    // } else {
    //     $('.shopify-section.section-float-nav, .shopify-section.section-float-nav-new').css('top', '38px');
    // }

    if (parseInt(dom.scrollTop()) > parseInt(curHeight)) {
      $(
        '.shopify-section.section-float-nav .container-v2, .shopify-section.section-float-nav-new .container-v2'
      ).css('visibility', 'visible');
      isHideBar == 1
        ? $("div[id*='countdown_inzatB']").addClass('floatNavBottom')
        : $("div[id*='countdown_inzatB']").addClass(
            'floatNavBottom floatNavBottom1'
          );
    } else {
      $(
        '.shopify-section.section-float-nav .container-v2, .shopify-section.section-float-nav-new .container-v2'
      ).css('visibility', 'hidden');
      $("div[id*='countdown_inzatB']").removeClass(
        'floatNavBottom floatNavBottom1'
      );
    }
  } else {
    if (parseInt(dom.scrollTop()) > parseInt(curHeight)) {
      $(
        '.shopify-section.section-float-nav, .shopify-section.section-float-nav-new'
      ).css('z-index', '3');
      $(
        '.shopify-section.section-float-nav .container-v2, .shopify-section.section-float-nav-new  .container-v2'
      ).css('visibility', 'visible');
      $(
        '.shopify-section.section-float-nav, .shopify-section.section-float-nav-new'
      ).css('top', '38px');
    } else {
      $(
        '.shopify-section.section-float-nav .container-v2, .shopify-section.section-float-nav-new  .container-v2'
      ).css('visibility', 'hidden');
      $(
        '.shopify-section.section-float-nav, .shopify-section.section-float-nav-new'
      ).css('z-index', '-1');
    }
  }
}

//window.money_format = '${{amount}}';
window.shipping_fee = 0;
window.money_format = '${{amount}}';
window.settings_new = { moneyFormat: '\$\{\{ amount \}\}' };
Shopify.formatMoney = function (cents, format) {
  var value = '',
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || this.money_format;

  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function productDetailSwitchConfigMethod() {
  // 产品详情切换模板配置
  const detailSwitchDom = $('.productDetailSwitchConfig');
  if (detailSwitchDom.length > 0) {
    for (let i = 0; i < detailSwitchDom.length; i++) {
      const pcNum =
        $(detailSwitchDom[i]) && $(detailSwitchDom[i]).attr('pcNum')
          ? $(detailSwitchDom[i]).attr('pcNum')
          : 1;
      const mobileNum =
        $(detailSwitchDom[i]) && $(detailSwitchDom[i]).attr('mobileNum')
          ? $(detailSwitchDom[i]).attr('mobileNum')
          : 1;
      slickObject($(detailSwitchDom[i]), pcNum, mobileNum);
    }
  }
}

function getProductInfo(product_handle, ele_obj, callback) {
  if (product_handle) {
    try {
      jQuery.ajax({
        dataType: 'json',
        url: '/products/' + $.trim(product_handle) + '.js',
        cache: false,
        success: function (data) {
          callback && callback(ele_obj, data);
        },
        error: function () {},
      });
    } catch (e) {
      console.log(e);
    }
  }
}
function getInstagramProductInfo(ele_obj, product_info) {
  if (
    ele_obj &&
    ele_obj.length &&
    product_info &&
    typeof product_info.featured_image != 'undefined' &&
    product_info.featured_image
  ) {
    $(ele_obj)
      .find('a')
      .attr('href', product_info.url)
      .attr('title', product_info.title);
    $(ele_obj)
      .find('img.img-responsive')
      .attr('src', product_info.featured_image + '&width=200')
      .attr('title', product_info.title)
      .attr('alt', product_info.featured_image.alt);
    if (product_info.compare_at_price == null) {
      $(ele_obj)
        .find('span.price')
        .html(Shopify.formatMoney(product_info.price, window.money_format));
    } else {
      $(ele_obj)
        .find('span.price')
        .html(Shopify.formatMoney(product_info.price, window.money_format));
      $(ele_obj)
        .find('s.price-old')
        .html(
          Shopify.formatMoney(
            product_info.compare_at_price,
            window.money_format
          )
        );
    }
  }
}
var slickDom = null;
function instagramGalleryMethod() {
  // 相册页面功能
  if ($('.section-instagram-gallery').length <= 0) {
    return;
  }
  $(document).on('click', '.image-list-item', function () {
    let indexData = $(this).find('.img-box').attr('index');
    slickDom.slick('slickGoTo', Number(indexData) - 1);
    const curDom = $('.image-list-slick-modal .image-list-item-video');
    for (let i = 0; i < curDom.length; i++) {
      curDom[i].addEventListener('pause', function () {
        $(curDom[i]).siblings('.video-icon').show();
      });
      curDom[i].addEventListener('play', function () {
        $(curDom[i]).siblings('.video-icon').hide();
        const curDom1 = $('.image-list-slick-modal .image-list-item-video');
        for (let i = 0; i < curDom1.length; i++) {
          const curClass = $(curDom1[i]).parent().attr('class');
          if ($(curDom1[i]) && $(curDom1[i]).length > 0) {
            if (curClass.indexOf('slick-active') == 0) {
              $(curDom1[i])[0].pause();
            }
          }
        }
      });
      curDom[i].addEventListener('ended', function () {
        $(curDom[i]).siblings('.video-icon').show();
      });
    }
    setTimeout(function () {
      $('.image-list-slick-modal .video-icon').show();
      const modalWidth = $('.image-list-slick-modal')
        .find('.slick-track')
        .width();
      if ($(window).width() < 990 && modalWidth < 50) {
        $('.image-list-slick-modal')
          .find('.slick-track')
          .css('width', $(window).width() + 'px');
        $('.image-list-slick-modal')
          .find('.img-box')
          .css('width', $(window).width() + 'px');
      }
    }, 800);
    $('body').addClass('cartover');
    $('.image-list-slick-modal').show();
  });
  $(document).on('click', '.slick-modal-mask-close', function () {
    $('.image-list-slick-modal').hide();
    $('body').removeClass('cartover');
    pauseVideo();
  });

  $('.image-list-slick-modal .slick-modal-mask-close').on(
    'touchend',
    function (e) {
      $('.image-list-slick-modal').hide();
      $('body').removeClass('cartover');
      pauseVideo();
      e.preventDefault();
    }
  );
  $(document).on('click', '.image-list-slick-modal .video-icon', function () {
    pauseVideo();
    const $domVideo = $(this).siblings('video');
    if ($domVideo && $domVideo.length > 0) {
      $domVideo[0].play();
      $(this).hide();
    }
  });
  $(document).on(
    'click',
    '.section-instagram-gallery .next-slide',
    function (e) {
      pauseVideo();
      if (e && e.preventDefault) {
        e.preventDefault();
      } else {
        window.event.returnValue = false;
      }
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }
      return false;
    }
  );
  $(document).on(
    'click',
    '.section-instagram-gallery .prev-slide',
    function (e) {
      pauseVideo();
      if (e && e.preventDefault) {
        e.preventDefault();
      } else {
        window.event.returnValue = false;
      }
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }
      return false;
    }
  );
  function pauseVideo() {
    const curDom = $('.image-list-slick-modal .image-list-item-video');
    for (let i = 0; i < curDom.length; i++) {
      if ($(curDom[i]) && $(curDom[i]).length > 0) {
        $(curDom[i])[0].pause();
      }
    }
  }
  slickDom = $('.image-list-slick-modal .image-list-slick').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: isAppleMobile() ? false : true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: false,
    centerPadding: 0,
    prevArrow:
      '<span class="prev-slide" aria-label="prev"><i class="fa fa-angle-left"></i></span>',
    nextArrow:
      '<span class="next-slide" aria-label="next"><i class="fa fa-angle-right"></i></span>',
    //prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    //nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    focusOnSelect: false,
    swipe: isAppleMobile() ? false : true,
    //lazyLoad:'ondemand'
  });
  function initInstagramGalleryListSlick($list) {
    if (!$list || !$list.length || !$.fn.slick) {
      return;
    }

    if ($list.hasClass('slick-initialized')) {
      $list.slick('unslick');
    }

    var isDesktopGallery = $(window).width() > 990;
    var slideCountGallery = $list.children('.image-list-item').length;
    if (slideCountGallery <= 0) {
      return;
    }

    var slidesToShowGallery = isDesktopGallery
      ? Math.min(5.03, slideCountGallery)
      : 1.03;
    var slidesToScrollGallery = isDesktopGallery
      ? Math.min(5, slideCountGallery)
      : 1;

    $list.css({
      display: 'block',
      flexWrap: 'nowrap',
      opacity: 1,
    });

    $list.slick({
      slidesToShow: slidesToShowGallery,
      slidesToScroll: slidesToScrollGallery,
      dots: false,
      arrows: slideCountGallery > slidesToShowGallery,
      infinite: false,
      initialSlide: 0,
      vertical: false,
      verticalSwiping: false,
      centerMode: false,
      centerPadding: 0,
      prevArrow:
        '<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
      nextArrow:
        '<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
      focusOnSelect: false,
    });

    window.setTimeout(function () {
      if ($list.hasClass('slick-initialized')) {
        $list.slick('setPosition');
        $list.slick('slickGoTo', 0, true);
      }
    }, 0);
  }

  //var $instagramGalleryList = $('.js_section_instagram_gallery .image-list, .js_section_instagram_gallery_page .image-list');
  var $instagramGalleryList = $(
    '.js_section_instagram_gallery .image-list, .product-section .js_section_instagram_gallery_page .image-list'
  );
  var $galleryItems = $instagramGalleryList
    .first()
    .children('.image-list-item');
  var height1 = $galleryItems.first().width()
    ? $galleryItems.first().width()
    : $(window).width() / 2;
  $instagramGalleryList.each(function () {
    initInstagramGalleryListSlick($(this));
  });
  $('.js_section_instagram_gallery_index .image-list').slick({
    slidesToShow: $(window).width() > 990 ? 1.01 : 1.03,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: true,
    centerPadding: $(window).width() > 990 ? 0 : '0px',
    //prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    //nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    prevArrow:
      '<button type="button" class="prev-slide" aria-label="prev"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
    nextArrow:
      '<button type="button" class="next-slide" aria-label="next"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
    focusOnSelect: false,
    initialSlide: 1,
    adaptiveHeight: false,
    //lazyLoad:'ondemand',
  });
  slickDom.on('afterChange', function (e, slick, currentSlide) {
    if (e && e.preventDefault) {
      e.preventDefault();
    } else {
      window.event.returnValue = false;
    }
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
  });
  const isHaveClassDom = $(
    '.section-instagram-gallery .js_section_instagram_gallery_index'
  );
  if (isHaveClassDom.length > 0) {
    $('.image-list-item .img-box img').css('height', height1 / 2 + 'px');
    const isPc = $(window).width() > 990 ? true : false;
    const imageDom = $('.image-list-item-outer');
    for (let i = 0; i < imageDom.length; i++) {
      const firstDom = $(imageDom[i]).children().eq(0); //第一个元素
      if (isPc) {
        firstDom.find('.img-box img').css('height', height1 + 20 + 'px');
      } else {
        firstDom.find('.img-box img').css('height', height1 + 10 + 'px');
      }
    }
  } else {
    $(
      '.js_section_instagram_gallery .image-list-item .img-box img, .js_section_instagram_gallery_page .image-list-item .img-box img'
    ).css('height', height1 + 'px');
  }
  $(
    '.js_section_instagram_gallery .image-list, .js_section_instagram_gallery_page .image-list, .js_section_instagram_gallery_index .image-list'
  ).css('opacity', 1);
  $instagramGalleryList.each(function () {
    var $list = $(this);
    if ($list.hasClass('slick-initialized')) {
      $list.slick('setPosition');
      $list.slick('slickGoTo', 0, true);
    }
  });
}
// 是否为 iPhone
function isAppleMobile() {
  return navigator.platform.indexOf('iPhone') != -1;
}
function getProductnstagram(section_filename, ele_obj, data) {
  var product_handle_contain = 0;
  var related_product_new = $('#product_spu_title');
  var related_product_handle = related_product_new.attr('product_handle');
  var related_product_handle_arr = related_product_handle.split(',');
  let $res_html = $(data[section_filename]);
  let current_product_sku_ele = $('#current-product-all-sku');

  if (typeof data[section_filename] != 'undefined' && data[section_filename]) {
    for (var i = 0; i < related_product_handle_arr.length; i++) {
      if (
        data[section_filename].indexOf('/' + related_product_handle_arr[i]) !==
        -1
      ) {
        product_handle_contain = 1;
      }
    }
  }

  //ele_obj.before($res_html);
  if (product_handle_contain == 1) {
    if (product_handle_contain == 1) {
      ele_obj.before(data[section_filename]);
      $('.section-instagram-gallery .instagram_gallery_title').html(
        'Find #UPOSOJA In Media'
      );
      var img_box_index = 0;
      $('.image-list .image-list-item').each(function () {
        let listProductHandle = $(this).attr('product_handle') || '';
        if (listProductHandle.charAt(0) === '/') {
          listProductHandle = listProductHandle.substring(1);
        }
        if (related_product_handle.indexOf(listProductHandle) === -1) {
          $(this).remove();
        } else {
          $(this).find('.img-box').attr('index', ++img_box_index);
        }
      });
      img_box_index = 0;
      $('.image-list-slick .img-box').each(function () {
        let modalProductHandle = $(this)
          .attr('product_handle')
          .replace(/\r/g, '')
          .replace(/\n/g, '')
          .replace(/\\n/g, '')
          .trim();
        if (modalProductHandle.charAt(0) === '/') {
          modalProductHandle = modalProductHandle.substring(1);
        }
        if (related_product_handle.indexOf(modalProductHandle) === -1) {
          $(this).remove();
        } else {
          $(this).attr('index', ++img_box_index);
        }
      });
      instagramGalleryMethod();
      $('.instagram_product_handle').each(function () {
        var product_handle_str = $(this).attr('data');
        var product_info = getProductInfo(
          product_handle_str,
          $(this),
          getInstagramProductInfo
        );
      });
    }
  }
}

function showTotalData(data, flag) {
  const moneyFormat = getSafeMoneyFormat();
  const shippingFee = Number(window.shipping_fee) || 0;
  if (data.items.length <= 0) {
    return;
  }
  if (data.total_discount > 0) {
    var code_list = [];
    if (data.cart_level_discount_applications.length > 0) {
      data.cart_level_discount_applications.forEach((i) => {
        if (typeof i.discount_application != 'undefined') {
          code_list.push(i.discount_application.title.toUpperCase());
        } else if (typeof i.title != 'undefined') {
          code_list.push(i.title.toUpperCase());
        }
      });
    } else if (data.discount_codes.length > 0) {
      data.discount_codes.forEach((i) => {
        if (i.applicable == true) {
          if (typeof i.code != 'undefined') {
            code_list.push(i.code.toUpperCase());
          } else if (typeof i.title != 'undefined') {
            code_list.push(i.title.toUpperCase());
          }
        }
      });
    }
    var code_html = '';
    code_list.forEach((item_c) => {
      code_html +=
        '<span class="applied-discount-code-wrapper" style="display: inline-flex;" data="' +
        item_c +
        '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" aria-hidden="true"><path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z"></path><circle cx="9.1" cy="4.9" r="0.7"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005v-.005Z"></path></svg><span class="applied-discount-code-value" data="' +
        item_c +
        '">' +
        item_c +
        '</span><button type="button" id="clear-discount-btn" data="' +
        item_c +
        '" aria-label="Remove discount code ' +
        item_c +
        '">X</button></span>';
    });
    $('.applied-discount-code').html(code_html);
    $('.applied-discount-code2').removeClass('hide');
    $('.cart-items-subtotal').html(
      Shopify.formatMoney(data.items_subtotal_price, moneyFormat)
    );
    $('.cart-items-discount').html(
      '-' + Shopify.formatMoney(data.total_discount, moneyFormat)
    );
    let cart_total = data.total_price + shippingFee;
    $('.cart_total_money').html(
      Shopify.formatMoney(data.total_price, moneyFormat)
    );
  } else {
    $('.applied-discount-code').html('');
    $('.applied-discount-code2').addClass('hide');
    if (flag) {
      $('.discount-code-error').html('Please Enter Valid Coupon Code.');
    }
    $('.cart-items-subtotal').html(
      Shopify.formatMoney(data.items_subtotal_price, moneyFormat)
    );
    $('.cart-items-discount').html(
      '-' + Shopify.formatMoney(data.total_discount, moneyFormat)
    );
    let cart_total = data.total_price + shippingFee;
    $('.cart_total_money').html(Shopify.formatMoney(cart_total, moneyFormat));
  }
  try {
    if ($('#cart-items-discount-save-price').length > 0) {
      var cart_items_discount_save_price = parseInt(
        $.trim($('#cart-items-discount-save-price').attr('value'))
      );
      if (cart_items_discount_save_price > 0) {
        data.total_discount =
          data.total_discount + cart_items_discount_save_price;
      }
    }
  } catch (e) {
    console.log(e);
  }
  if ($('.cart_total_savings').length > 0) {
    if (data.total_discount > 0) {
      $('.cart_total_savings').html(
        'Savings: ' + Shopify.formatMoney(data.total_discount, moneyFormat)
      );
      $('.cart_total_savings').removeClass('hide');
    } else {
      $('.cart_total_savings').addClass('hide');
    }
  }
}

let shippingRateRequestInFlight = false;
function requestShippingRate() {
  if (shippingRateRequestInFlight) {
    return;
  }
  shippingRateRequestInFlight = true;
  const moneyFormat = getSafeMoneyFormat();
  fetch('/cart/shipping_rates.json', {
    method: 'POST',
    body: JSON.stringify({
      shipping_address: {
        zip: '77523',
        country: 'United States',
        province: 'Texas',
      },
    }),
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then(function (parsedState) {
      if (
        parsedState &&
        parsedState.shipping_rates &&
        parsedState.shipping_rates.length > 0 &&
        parsedState.shipping_rates[0].price >= 0
      ) {
        window.shipping_fee = parsedState.shipping_rates[0].price * 100;
        const shippingFee = Number(window.shipping_fee) || 0;
        var cart_shipping_fee_money = document.querySelectorAll(
          '.cart_shipping_fee_money'
        );
        for (var i = 0; i < cart_shipping_fee_money.length; i++) {
          cart_shipping_fee_money[i].innerHTML = Shopify.formatMoney(
            shipping_fee,
            moneyFormat
          );
          cart_shipping_fee_money[i].style = 'opacity: 1';
        }
        let cart_total = 0;
        if ($('.template-cart').length > 0) {
          cart_total =
            parseInt($('.cart__footer .cart_total_money').attr('data-price')) +
            shipping_fee;
        } else {
          cart_total =
            parseInt($('.cart_total_money').attr('data-price')) + shipping_fee;
        }
        $('.cart_total_money').html(
          Shopify.formatMoney(cart_total, moneyFormat)
        );
      }
    })
    .catch((e) => console.error(e))
    .finally(function () {
      shippingRateRequestInFlight = false;
    });
}

let throttledGetShippingRate =
  typeof throttle === 'function'
    ? throttle(requestShippingRate, 1000)
    : requestShippingRate; // 节流
function getShippingRate() {
  throttledGetShippingRate();
}

function clearDiscount(current_code) {
  $('.discount-code-error').html('');
  $('.applied-discount-code .applied-discount-code-wrapper').each(function () {
    if ($(this).attr('data') == current_code) {
      $(this).remove();
    }
  });
  var code_arr = [];
  $('.applied-discount-code .applied-discount-code-wrapper').each(function () {
    code_arr.push($(this).attr('data'));
  });
  if (code_arr.length > 0) {
    var code_temp = code_arr.join(',');
  } else {
    var code_temp = 'none';
  }
  $('.enj-minicart-ajax .total-info-order .cart-items-subtotal').html('');
  $('.enj-minicart-ajax .total-info-order .cart-items-discount').html('');
  $('.enj-minicart-ajax .prod').addClass('noDiscount');
  /*fetch("/discount/CLEAR").then(function(data){*/
  fetch('/checkout?discount=' + code_temp).then(function (data) {
    fetch('/cart.js', {})
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        showTotalData(data, 0);
      });
  });
}
function applyDiscount(code) {
  if ($.trim(code).length <= 0) {
    return;
  }
  code = code.toUpperCase();
  var code_arr = [];
  $('.applied-discount-code .applied-discount-code-wrapper').each(function () {
    code_arr.push($(this).attr('data'));
  });
  if (code_arr.indexOf(code) !== -1) {
    return;
  }
  code_arr.push(code);
  var code_temp = code_arr.join(',');
  $('.discount-code-error').html('');
  $('.apply-discount-btn')
    .addClass('btn--loading')
    .html("Apply <div class='loader'></div>");
  $('.apply-discount-btn').css('pointerEvents', 'none');
  /*fetch(`/discount/${code_temp}`)*/
  fetch('/checkout?discount=' + code_temp)
    .then(function () {
      // After the discount code has been applied, force the cart to update so the discount is visible
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: {},
        }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          showTotalData(data, 1);
          $('.apply-discount-btn').html('Apply');
        });
    })
    .then(function () {
      // 更新购物车显示（如果需要）
      console.log('Please Enter Valid Coupon Code.');
    })
    .catch(function (error) {
      console.error('Error--:', error);
    })
    .finally(function (params) {
      $('.apply-discount-btn').removeClass('btn--loading').html('Apply');
      $('.apply-discount-btn').css('pointer-events', 'all');
    });
}

function getSafeMoneyFormat() {
  if (window.settings_new && window.settings_new.moneyFormat) {
    return window.settings_new.moneyFormat;
  }
  if (window.money_format) {
    return window.money_format;
  }
  return '${{amount}}';
}
